import { render } from "./menu-handler.vue?vue&type=template&id=5ede7193"
import script from "./menu-handler.vue?vue&type=script&lang=js"
export * from "./menu-handler.vue?vue&type=script&lang=js"

import "./menu-handler.vue?vue&type=style&index=0&id=5ede7193&lang=css"

import exportComponent from "/home/rowen/www/html/catholic-club-fleet-base/themes/default/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__